import removeAccents from 'utils/removeAccents';

const search = (searchString, ...fields) =>
  removeAccents(searchString)
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .reduce((ret, str) => ret && removeAccents(fields.join(' ')).toLowerCase().includes(str), true);

export default search;
